import { Resources } from 'constants/resources';

import { useMemo } from 'react';

import { useGetList } from 'react-admin';
import { Gateway } from 'types/embedded/gateway';
import { getGatewayCurrencyIds } from 'utils/getGatewayCurrencyIds';

export const useProviderCurrencyIds = (provider?: string | null): string[] => {
  const { data: gateways = [] } = useGetList<Gateway>(
    Resources.Gateways,
    {
      filter: { provider },
      pagination: { page: 1, perPage: 200 },
      sort: { field: 'id', order: 'ASC' },
    },
    { enabled: Boolean(provider) },
  );

  return useMemo(() => Array.from(new Set(gateways.flatMap(getGatewayCurrencyIds))), [gateways]);
};
